// @packages
import React, { useEffect, useState } from 'react';
import {
  View
} from 'react-native';
import { ListItem } from '@rneui/themed';

// @scripts
import ScheduleItem from '../../atoms/schedule-item';
import StrategiesService from '../../../services/strategies-service';
import useStyles from './styles';
import { IEnrollment, ISchedule, ISession } from '../../../utils/types';
import { config } from '../../../core/config';

const texts = config.text;

type Props = {
  currentSiteId: number,
  schedules: ISchedule[]
};

const SchedulesList = ({
  currentSiteId,
  schedules
}: Props) => {
  const styles = useStyles();
  const [names, setNames] = useState<IEnrollment[]>([]);
  const [sessionsFormatted, setSessionsFormatted] = useState<ISession[]>([]);

  const getNames = async () => {
    setNames(await StrategiesService.getSiteEnrollment(currentSiteId));
  };

  const addStrategyNameToSessionItems = (
    item: ISchedule
  ) => item.sessions.map((s) => {
    s.name = names.find((strategy) => (strategy.strategy_id === item.strategy_id))?.name ?? 'unknown';
    return s;
  });

  const formatSchedules = () => {
    const sessionItems = schedules && schedules.length > 1
      ? schedules.reduce<ISession[]>(
        (items, nextSchedule) => [...items, ...addStrategyNameToSessionItems(nextSchedule)],
        []
      )
      : schedules.flatMap((schedule) => addStrategyNameToSessionItems(schedule));

    setSessionsFormatted(sessionItems);
  };

  useEffect(() => {
    getNames();
  }, []);

  useEffect(() => {
    formatSchedules();
  }, [schedules, names]);

  return (
    <View style={styles.container}>

      <ListItem style={styles.listItem}>
        <ListItem.Content style={styles.firstColumn}>
          <ListItem.Title style={styles.title}>
            {texts.siteScheduleDetail.strategy}
          </ListItem.Title>
        </ListItem.Content>
        <ListItem.Content style={styles.secondColumn}>
          <ListItem.Title style={styles.title}>
            Start
          </ListItem.Title>
        </ListItem.Content>
        <ListItem.Content style={styles.secondColumn}>
          <ListItem.Title style={styles.title}>
            End
          </ListItem.Title>
        </ListItem.Content>
      </ListItem>
      <ScheduleItem sessionsFormatted={sessionsFormatted} />
    </View>
  );
};

export default SchedulesList;
